import { assoc, compose, dissoc, pick, prop, map, propOr, addIndex } from 'ramda'

// Note: SORT constant removed - translations are handled in components
// This file only handles data transformation, not UI display

const cleanLinktreeItem = (linktree, index) =>
  compose(
    pick(['enabled', 'label', 'url', 'isDefault', 'id', 'icon', 'ordination', 'linkTreeId', 'configuration']),
    assoc('ordination', index),
    cleanUrl,
    cleanConfiguration
  )(linktree)

export const cleanRequest = linktrees => {
  const mapIndexed = addIndex(map)

  return mapIndexed(cleanLinktreeItem, linktrees)
}

const cleanUrl = item => {
  const PROTOCOLS = 'http|https|dhcp|xmpp|ftp|sftp|ftps|ssh|pop|imap|smtp'
  const PROTOCOL_PATTERN = new RegExp(`^((${PROTOCOLS})?://?)(.*)`)
  if (item.url && !PROTOCOL_PATTERN.test(item.url)) return compose(assoc('url', `http://${item.url}`))(item)
  return compose(assoc('url', item.url))(item)
}

const cleanConfiguration = item => {
  const configuration = prop('configuration', item)

  if (!configuration?.isPublicHistory) return dissoc('configuration')(item)

  // Default values - names will be translated in UI components
  const defaultSort = {
    field: { name: 'Id', id: 'ID' },
    type: { name: 'Ascendente', id: 'ASC' }
  }

  return assoc(
    'configuration',
    JSON.stringify(
      compose(
        pick(['sort', 'filter', 'isPublicHistory']),
        assoc(
          'sort',
          compose(
            pick(['field', 'type']),
            assoc('field', configuration?.sort?.field ?? defaultSort.field),
            assoc('type', configuration?.sort?.type ?? defaultSort.type)
          )(configuration)
        ),
        assoc(
          'filter',
          compose(
            pick(['questions', 'statuses']),
            assoc(`questions`, configuration?.filter?.questions),
            assoc(`statuses`, configuration?.filter?.statuses)
          )(configuration)
        )
      )(configuration)
    ),
    item
  )
}
